// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3Icm0","content":"styles_content__1lqWN","checkbox":"styles_checkbox__1Yrvf","checkboxLabel":"styles_checkboxLabel__YvNCL"};